import AdminLandingPage from "./AdminLandingPage";
import HiringManagerLandingPage from "./HiringManagerLandingPage";
import ContractorLandingPage from "./ContractorLandingPage";
import ITLandingPage from "./ITLandingPage";
import ManagerLandingPage from "./ManagerLandingPage";
import FinancialControllerLandingPage from "./FinancialControllerLandingPage";

export default function LandingRouter({ user }) {
  if (!user) return <h2>Loading...</h2>;

  const role = typeof user.Role === "string" ? user.Role.toLowerCase() : "";

  switch (role) {
    case "admin":
    case "tgs-approver":
    case "tgs-admin":
      return <AdminLandingPage user={user} />;
    case "hiring manager":
    case "proxyhiringmanager":
      return <HiringManagerLandingPage user={user} />;
    case "candidate":
    case "employee":
      return <ContractorLandingPage user={user} />;
    case "it":
      return <ITLandingPage user={user} />;
    case "manager":
      return <ManagerLandingPage user={user} />;
    case "financial controller":
      return <FinancialControllerLandingPage user={user} />;

    default:
      return (
        <div>
          <h2>
            Welcome {user.FirstName} {user.LastName}
          </h2>
          <p>Your role does not yet have a landing page.</p>
        </div>
      );
  }
}
